import { render } from "./VenueAdminItem.vue?vue&type=template&id=dc5161c4"
import script from "./VenueAdminItem.vue?vue&type=script&lang=js"
export * from "./VenueAdminItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__